import React from 'react'
import { FormControl, Grid } from '@mui/material'
import { DatePicker } from '@mui/x-date-pickers'

import s from './styles.module.scss'

const Header = ({ centre, currentDate, setCurrentDate }) => {
  return (
    <Grid container className={s.header}>
      <Grid item xs={12} sm={12} md={6} className={s.centreName}>
        <div>Estadisticas</div>
      </Grid>
      <Grid item xs={12} sm={12} md={6} className={s.datePickerContainer}>
        <FormControl variant="standard" className={s.datePicker}>
          <DatePicker
            label="Fecha *"
            views={['year', 'month']}
            openTo="month"
            value={currentDate}
            format="MM-YYYY"
            onChange={(newDate) => {
              setCurrentDate(newDate)
            }}
            slotProps={{
              textField: {
                variant: 'standard',
              },
            }}
          />
        </FormControl>
      </Grid>
    </Grid>
  )
}

export default Header
